/**
 * A util library to support number formatting functions.
 */

// Format a number with grouped thousands using a delimiter
// Similar to `number_with_delimiter` in Rails:
// http://apidock.com/rails/ActionView/Helpers/NumberHelper/number_with_delimiter
export function formatNumberWithDelimiter(number, delimiter = ",") {
  return number.toString().replace(/(\d)(?=(\d{3})+$)/g, `$1${  delimiter}`);
}

export function formatPercentage(numerator, denominator) {
  if (numerator === null || denominator === null) {
    return null;
  } else if (denominator === 0) {
    return null;
  } else {
    return `${((numerator / denominator) * 100).toFixed()}%`;
  }
}

/**
 * Formats a fraction with percent. Usually used for reading progress
 * or reading challenge progress.
 *
 * @param value aka the numerator
 * @param max aka the denominator
 * @returns {string} e.g. "10/100 (10%)"
 */
export function fractionWithPercentage(value, max) {
  const percentage = formatPercentage(value, max);
  
  if (percentage) {
    return `${value}/${max} (${percentage})`;
  } else {
    return null;
  }
}

